export default {
  aggregates: {
    aggregated: 'Aggregierte Ergebnisse',
    aggregatedDate: '{startDate} – {fromDate}',
    ago: 'vor',
    from: 'von',
    since: 'seit',
    unit: {
      DAY: 'Tag|Tage',
      MONTH: 'Monat|Monate',
      YEAR: 'Jahr|Jahre'
    },
    untilNow: 'bis jetzt'
  },
  categoryDetails: {
    average: 'Durchschnittswert:',
    chartLabel: {
      noLabel: 'Nein',
      yesLabel: 'Ja'
    },
    description:
      'Dies zeigt, wie die Antworten des Teams auf alle Fragen in der Kategorie verteilt sind.',
    hideOwnAnswers: 'Eigene Antworten ausblenden',
    noResponses: 'Keine Antworten',
    notParticipating: 'Du hast diese Fragen nicht selbst beantwortet.',
    numberOfPeople: 'Antwortende',
    sensitiveQuestion:
      'Dieses Ergebnis ist für deine Mitarbeiter nicht sichtbar.',
    showFollowUpQuestions: 'Folgefragen anzeigen',
    toggleButton: {
      overview: 'Übersicht',
      questions: 'Fragen'
    },
    tooltip: {
      barValue: 'Niemand | {count} Person | {count} Menschen',
      barValueAnswers: 'niemand | {count} Antwort | {count} Antworten'
    },
    workWith: '{categoryName} verbessern',
    yourResponse: 'Deine Antwort:'
  },
  error: {
    couldNotLoadAggregates:
      'Aggregierte Ergebnisse konnten nicht geladen werden.',
    couldNotLoadResults: 'Ergebnisse konnten nicht geladen werden.',
    networkError:
      'Es gab ein Problem beim Herunterladen von Daten aus dem Internet. Funktioniert deine Internetverbindung?',
    unknown: 'Es liegt ein unbekannter Fehler vor'
  },
  errors: {
    status: {
      BadRequest: 'Fehlerhafte Anfrage an den Server.',
      Forbidden: 'Der Zugriff auf diese Ressource ist nicht zulässig.',
      InternalServerError:
        'Auf dem Server ist ein Fehler aufgetreten. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den Support.',
      NotFound: 'Das gesuchte Element konnte nicht gefunden werden.',
      Unauthorized:
        'Sie sind nicht berechtigt, auf diese Ressource zuzugreifen.',
      UnknownError: 'Unbekannter Fehler'
    }
  },
  freetext: {
    loadResponses: 'Antworten laden',
    noFreeTextQuestions:
      'Wenn Ihre Umfrage Freitextfragen enthält, können Sie hier alle Antworten sehen.',
    notEnoughResponses: 'Nicht genügend Antworten.',
    responses: 'Keine Antworten|{count} Antwort | {count} Antworten'
  },
  general: {
    add: 'Hinzufügen',
    cancel: 'Abbrechen',
    entireOrganization: 'Gesamtes Unternehmen',
    ok: 'OK'
  },
  groupsComparison: {
    averageForItem:
      '{value} ist der Durchschnittswert für Fragen innerhalb von {title}. {compareToBenchmark}',
    currentValue: 'Aktueller Wert',
    filter: {
      findGroups: 'Gruppen finden',
      shouldExportWithHierarchy: 'Untergruppen einschließen'
    },
    loadMore: 'Mehr laden',
    loadMoreInGroup: 'Weitere Antworten laden unter {groupName}',
    noone: 'Niemand hat geantwortet',
    noResults:
      'Noch nicht genug Antworten für diese Gruppe. {numberOfUsersThatHaveRespondedText}.',
    noResultsResponded: 'haben geantwortet',
    nps: 'Net Promoter Score',
    nps_detractors: 'Detractors',
    nps_passives: 'Passives',
    nps_promoters: 'Promoters',
    questions: 'Fragen in der Kategorie',
    showTrend: 'Änderung anzeigen',
    violationsIn:
      'Es wurde gemeldet, dass es innerhalb von {groupName} zu Verstößen gekommen ist. Bitte wende dich an die Personalabteilung, die dir Näheres darüber sagen und dich beim weiteren Umgang mit dem Problem unterstützen kann.'
  },
  history: {
    selectorDescriptions: {
      noCustomDateSelected:
        'Wählen Sie ein Datum als Startpunkt für den Verlauf aus.',
      selectDate:
        'Zeigt den Verlauf von Umfragen seit dem angegebenen {date} an.',
      selectedDate: 'Verlauf für Umfragen seit {date} anzeigen.'
    },
    selectorOptions: {
      custom: 'Benutzerdefiniert',
      oneMonth: '1m',
      oneYear: '12m',
      sixMonths: '6m'
    }
  },
  loading: {
    error: {
      link: 'Nochmal versuchen'
    }
  },
  navbar: {
    administration: 'Admin',
    currentSurveys: 'Aktuelle Umfragen',
    help: 'Hilfe',
    myActivities: 'Aktionen',
    ourResults: 'Ergebnisse',
    overview: 'Übersicht',
    team: 'Team',
    welcome: 'Herzlich willkommen'
  },
  page: {
    results: 'Alle Ergebnisse'
  },
  resultDetails: {
    backToResults: 'Zurück',
    exportData: 'Exportieren',
    exportModal: {
      includeSensitiveQuestions: 'Sensible Fragen miteinbeziehen',
      loadingMessage:
        'Daten werden für den Export vorbereitet, einen Moment bitte!',
      saveAsExcelAllGroupsDescription:
        'Durch den Export nach Excel erhalten Sie eine Datei mit den Ergebnissen für {groupTitle} und alle Untergruppen.. Das ist sinnvoll, wenn Sie eigene Mehrgruppenanalysen oder Berechnungen für mehrere Gruppen durchführen möchten.',
      saveAsExcelButton: 'Excel',
      saveAsExcelDescription:
        'Durch den Export nach Excel erhalten Sie eine Datei mit den Ergebnissen für {groupTitle}{segmentInfo}. Dies empfiehlt sich, wenn Sie eigene Analysen oder Berechnungen durchführen möchten.',
      saveAsPdfButton: 'PDF',
      saveAsPdfDescription:
        'Sie erhalten ein PDF-Dokument mit den Ergebnissen aller Kategorien und Fragen der ausgewählten Gruppe. Das ist praktisch, wenn Sie die Ergebnisse ausdrucken möchten.',
      saveAsPowerPointButton: 'PowerPoint',
      saveAsPowerPointDescription:
        'Mit einem PowerPoint-Export erhalten Sie eine ansprechende Präsentation, die die Ergebnisse für {groupTitle} {segmentInfo} enthält. Das ist ideal, wenn Sie die Ergebnisse anderen auf einem großen Bildschirm präsentieren möchten.'
    },
    notes: {
      draggable: {
        explanation: 'Nur für Sie sichtbar',
        placeholder:
          'Schreiben Sie hier Ihre eigenen Notizen, Kommentare und Überlegungen zur Umfrage',
        title: 'Persönliche Notizen'
      },
      status: {
        initial: 'Automatisches Speichern während der Eingabe',
        saved: 'Änderungen gespeichert!',
        unsaved: 'Speicherung erfolgt demnächst...'
      }
    },
    tagDetails: {
      color: {
        alerts: {
          notEnoughResponses:
            'Es gibt nicht genug Antworten, um die Ergebnisse pro Benutzer anzuzeigen'
        },
        description: {
          high: 'Eine Person hat geantwortet, so dass ihre Durchschnittspunktzahl grün wurde.|Es gibt {count} Personen, die geantwortet haben, so dass ihre Durchschnittsnote grün wurde.',
          low: 'Eine Person hat geantwortet, so dass ihre Durchschnittsnote rot wurde. Es gibt {count} Personen, die geantwortet haben, so dass ihre Durchschnittsnote rot wurde.',
          medium:
            'Eine Person hat geantwortet, so dass ihre Durchschnittsnote gelb wurde. Es gibt {count} Personen, die geantwortet haben, so dass ihre Durchschnittsnote gelb wurde.'
        },
        title: 'Keiner|Eine Person|{count} Personen'
      },
      currentValue: {
        equalsToBenchmarkValue:
          'Ihr Score ist derselbe wie der Pulsᐩ benchmark® für {title}.',
        higherThanBenchmarkValue:
          'Ihr Score ist {benchmarkDiff} höher als der Pulsᐩ benchmark® für {title}, der {benchmarkValue} beträgt. Sehr schön!',
        lowerThanBenchmarkValue:
          'Sie liegen {benchmarkDiff} niedriger als der Pulsᐩ benchmark® für {title}, der {benchmarkValue} beträgt.',
        percentagePoints: 'Prozentpunkte'
      },
      enps: {
        button: {
          description:
            'Sie werden zu unserem Partner EQI weitergeleitet, der Vergleichsdaten für eine große Anzahl von Organisationen erfasst und detailliertere Informationen über Ihren eigenen eNPS-Score liefert.',
          title:
            'Vergleichen Sie Ihren eNPS-Score mit dem anderer Organisationen'
        }
      },
      toggleButton: {
        history: 'Verlauf',
        overview: 'Übersicht'
      }
    }
  },
  results: {
    aggregated: 'Aggregiert',
    chooseSurvey: 'Umfrage auswählen',
    finished: 'Fertig',
    published: 'Laufend'
  },
  resultsmessages: {
    disclaimer: 'Pulsᐩ AI verwendet generative KI und kann Fehler machen.',
    error: {
      generic:
        'Oh, leider funktioniert hier etwas nicht wie erwartet. Bitte laden Sie die Seite neu.',
      notEnoughResults:
        'Es gibt keine Ergebnisse. Wählen Sie bitte eine andere Gruppe oder Umfrage aus, um Pulsᐩ AI zu verwenden.'
    },
    moreInfo: 'Erfahren Sie, wie Sie als Führungskraft Pulsᐩ AI nutzen können',
    moreInfoLink: 'https://www.puls-solutions.com/help/#/section/1/articles/10',
    placeholder: 'Stellen Sie eine Frage zu den Ergebnissen …',
    reload: 'Seite neu laden',
    report: 'Problem melden',
    send: 'Senden',
    suggestionHeader:
      'Es folgen einige Vorschläge für mögliche Fragen, die Sie stellen können:',
    suggestions: {
      groupsComparison: {
        1: 'Auf welche Gruppen sollte ich mich konzentrieren?',
        2: 'Gibt es eine Frage, an der die meisten Gruppen arbeiten sollten?',
        3: 'Welche Gruppen zeigen negative Trends?',
        4: 'Welche Gruppen haben positive Trends?',
        5: 'Welche Gruppen fallen negativ auf?',
        6: 'Welche Gruppen benötigen meine Aufmerksamkeit?',
        7: 'Was sollte ich zuerst tun?'
      },
      overview: {
        1: 'Was soll ich mit unserem Ergebnis tun?',
        2: 'Wie soll ich das Ergebnis meinem Team präsentieren?',
        3: 'Wie sehen die Ergebnisse insgesamt aus?',
        4: 'Was sind die 3 wichtigsten Maßnahmen, die wir treffen sollten?',
        5: 'Was kann ich an meiner Führung verbessern?',
        6: 'Welche Risiken gibt es für uns?',
        7: 'Was kann passieren, wenn wir nicht handeln?',
        8: 'Welche Prioritäten soll ich setzen?',
        9: 'Wie sieht die Prognose für mein Team aus?'
      }
    },
    title: 'Pulsᐩ AI'
  },
  resultsPerAttribute: {
    attributes: {
      all: {
        title: 'Alle'
      }
    }
  },
  sections: {
    resultsForSurvey: {
      tabs: {
        compare: {
          title: 'Vergleichen'
        },
        export: {
          title: 'Exportieren'
        },
        freetext: {
          title: 'Freitext'
        },
        results: {
          title: 'Umfrageergebnisse'
        }
      }
    }
  },
  segmentedDetails: {
    notEnoughResponses:
      'Es ist nicht möglich, Statistiken anzuzeigen, ohne die Anonymität zu verlieren.',
    others: 'Anderer | Andere',
    tooltip: {
      barValue: '{numberOfPeople} {segment}'
    }
  },
  sidebar: {
    administration: 'Verwaltung',
    currentSurveys: 'Aktuelle Umfragen',
    dashboard: 'Instrumententafel',
    help: 'Hilfe',
    logOut: 'Ausloggen',
    myActivities: 'Meine Aktionen',
    ourResults: 'Unsere Ergebnisse'
  },
  topbanner: {
    preview: {
      body: 'Sie sehen nun die neue Version der Pulsᐩ Ergebnisansicht mit zahlreichen Verbesserungen! Wenn etwas nicht wie erwartet funktioniert oder Sie Feedback haben, lassen Sie es uns bitte wissen! Sie können auch zur alten Version zurückkehren.',
      header: 'Neue Version!'
    }
  },
  trendArrow: {
    category: {
      tooltip: {
        trend_decreased:
          'Während des Zeitraums {startDate} - {endDate} ist das Ergebnis für {categoryName} gesunken.',
        trend_increased:
          'Während des Zeitraums {startDate} - {endDate} hat sich das Ergebnis für {categoryName} erhöht. Macht weiter so!',
        trend_same:
          'Das Ergebnis ist für {CategoryName} während des Zeitraums {startDate} - {endDate} dasselbe geblieben.'
      }
    },
    noTrend:
      'Es existiert keine ältere Umfrage, mit der man vergleichen könnte.',
    tag: {
      tooltip: {
        nps_trend_decreased:
          'Im Vergleich zur vorherigen Umfrage am {oldSurveyDate} ist das Ergebnis für {tagName} um {changeInPercent}% zurückgegangen.',
        nps_trend_increased:
          'Im Vergleich zu der vorherigen Umfrage am {oldSurveyDate} ist das Ergebnis für {tagName} um {changeInPercent}% gestiegen.',
        nps_trend_same:
          'Das Ergebnis ist seit der letzten Umfrage am {oldSurveyDate} für {tagName} mit etwa ({changeInPercent}% change) das selbe geblieben.',
        trend_decreased:
          'Während des Zeitraums {startDate} - {endDate} hat sich das Ergebnis für {tagName} verringert.',
        trend_increased:
          'Während des Zeitraums {startDate} - {endDate} hat sich das Ergebnis für {tagName} erhöht',
        trend_same:
          'Das Ergebnis ist für {CategoryName} während des Zeitraums {startDate} - {endDate} dasselbe geblieben.'
      }
    }
  },
  utilityBar: {
    allGroups: 'Alle Gruppen',
    cannotChangeGroupsWhileComparing:
      'In der Vergleichsansicht sehen Sie mehrere Gruppen gleichzeitig.',
    group: 'Gruppe',
    segment: 'Segment',
    survey: 'Umfrage'
  },
  widgetActionsSummary: {
    labels: {
      peopleThatSelectedAnAction:
        'Anzahl der Personen, die mindestens eine Aktion ausgewählt haben',
      totalActions: 'Gesamtzahl der ausgewählten Aktionen'
    },
    title: 'Zusammenfassung der Aktionen'
  },
  widgetAlert: {
    actions: {
      saved: 'Vielen Dank, die Aktivität wurde gespeichert.'
    },
    links: {
      tooltip: 'Link öffnet in einem neuen Fenster'
    },
    notEnoughData: 'Hier gibt es im Moment nichts anzuzeigen.'
  },
  widgetCategoriesBars: {
    aggregateInfo: {
      harassment: {
        info: 'Zuletzt gemeldet am {surveyDate}.'
      },
      question: {
        info: 'Zuletzt gefragt am {surveyDate} in "{surveyTitle}".'
      }
    },
    notEnoughResponses:
      'Es gibt noch nicht genug Antworten, um hier etwas anzuzeigen.',
    title: 'Kategorien',
    tooltip: {
      value:
        'Dies ist der Durchschnittswert für alle Antworten auf Fragen in der Kategorie {categoryName}, die von Personen in {groupName} beantwortet wurden.'
    }
  },
  widgetErrorFallback: {
    description:
      'Beim Laden des Widgets ist ein unerwarteter Fehler aufgetreten. Bitte laden Sie die Seite zunächst neu. Sollte das Problem weiterhin bestehen, melden Sie es uns bitte, damit wir uns umgehend darum kümmern können!',
    hideErrorDetails: 'Fehlerdetails ausblenden',
    showErrorDetails: 'Fehlerdetails anzeigen',
    title: 'Widget-Problem!'
  },
  widgetGroupActions: {
    allCategories: 'In allen Kategorien',
    freeText: {
      alert: {
        noResults: 'Nichts gefunden. Versuche, etwas anderes zu tippen.',
        typeMore: 'Tippe noch etwas mehr'
      },
      filterField: {
        placeholder: 'Tippen, um Kommentare zu finden'
      },
      numberOfComments: '{numberOfComments} Kommentare'
    },
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887258169',
        title:
          'Wie man persönliches Verantwortungsbewusstsein bei den Mitarbeitern entwickelt'
      }
    },
    noActions: 'Keine Aktionen zum Anzeigen.',
    noActionsSelectedInCategory: 'Es sind keine Aktionen ausgewählt',
    otherActions: 'Eigene Aktionen',
    people: 'Niemand | {count} Person | {count} Menschen',
    peopleSelectedActions:
      'Von {peopleResponded} Personen, die geantwortet haben, hat nur 1 mindestens eine Aktion ausgewählt ({percentage} %)| Von {peopleResponded} Personen, die geantwortet haben, haben {count} Personen mindestens eine Aktion ausgewählt ({percentage} %)',
    title: 'Aktionen für Personen in {groupName}',
    tooltip: {
      numberOfPeopleChoseActions:
        '1 Person hat diese Aktion gewählt| {count} Personen haben diese Aktion gewählt'
    }
  },
  widgetGroupPriorities: {
    description:
      'Dies sind die wichtigsten Bereiche, auf die sich die Umfrageteilnehmer derzeit konzentrieren.',
    freeTextResponses: 'Freitext-Antworten anzeigen',
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887214144',
        title: 'So entwickeln Sie Ihr Team mit Pulsᐩ'
      }
    },
    noPriorities: 'Es gibt keine von den Teilnehmern gewählten Prioritäten.',
    people: 'Niemand | {count} Person | {count} Menschen',
    thinkImportant: ' denke "{category}" ist am wichtigsten',
    title: 'Prioritäten für Personen in {groupName}'
  },
  widgetNotImplemented: {
    content: 'Noch nicht implementiert'
  },
  widgetSurveyInfo: {
    endDate: 'Endtermin:',
    noone: 'Noch niemand',
    notEnoughResponses: {
      aggregate:
        'Es gab nicht genügend Antworten innerhalb des Zeitraums, um valide Ergebnisse anzuzeigen.',
      completed:
        'Es gab nicht genügend Umfrageteilnehmer, um valide Ergebnisse anzuzeigen.',
      published:
        'Bisher haben noch zu wenige Personen an der Umfrage teilgenommen, um Ergebnisse anzuzeigen.'
    },
    participation: {
      title: 'Teilnahme'
    },
    startDate: 'Anfangsdatum:',
    status: {
      completed:
        'Die Umfrage ist abgeschlossen! Dies sind die endgültigen Ergebnisse.',
      published:
        'Die Umfrage ist noch nicht abgeschlossen. Die Ergebnisse sind vorläufig.'
    },
    usersInvited: 'Eingeladene Personen:',
    usersResponded: 'Die Leute antworteten:'
  },
  widgetTagsDonuts: {
    description: {
      all: 'Dies sind die neuesten Ergebnisse für {groupName}.'
    },
    notEnoughResponses:
      'Es gibt noch nicht genug Antworten, um hier etwas anzuzeigen.',
    title: {
      company: 'Alles von  {organizationName}'
    },
    tooltip: {
      enps_description:
        'eNPS steht für Employee Net Promoter Score und misst die Bereitschaft der Mitarbeiter, sich für eine Beschäftigung in ihrem Unternehmen einzusetzen',
      nps_description:
        'NPS steht für Net Promoter Score und ist ein Maß dafür, wie wahrscheinlich Menschen etwas empfehlen.',
      nps_detractors: 'Kritiker',
      nps_passives: 'Passive',
      nps_promoters: 'Förderer',
      value:
        'Dies ist der Durchschnittswert für alle Antworten auf Fragen in der Kategorie {tagName}, die von Personen in {groupName} beantwortet wurden.'
    }
  },
  widgetTagsTrends: {
    title: '{tagNames} im Laufe der Zeit',
    twoTags: '{tag1} und {tag2}'
  }
}
